import { render, staticRenderFns } from "./CreditRecord.vue?vue&type=template&id=6b9cfa62&"
import script from "./CreditRecord.vue?vue&type=script&lang=js&"
export * from "./CreditRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports